import { ListTableCard } from "@/accounts-payable/common";
import { useGetEmails } from "@/accounts-payable/query";
import {
  fromCol,
  subjectCol,
  receivedCol,
  invoicesCol,
  statusCol,
} from "./cols";

const columns = [fromCol, subjectCol, receivedCol, invoicesCol, statusCol];

export const ApEmailsTab = ({
  businessId,
  selectedId = null,
  onSelect,
}: {
  businessId: string | null;
  selectedId?: string | null;
  onSelect: (id: string) => void;
}) => {
  const query = useGetEmails(businessId);

  return (
    <ListTableCard
      query={query}
      columns={columns}
      selectedId={selectedId}
      onSelect={onSelect}
      empty={{
        title: "No emails yet",
        body: "Invoices emailed to your AP address will show up here.",
      }}
      error={{
        title: "Couldn’t load emails",
        body: "Please try again in a moment.",
      }}
    />
  );
};
